import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useAsyncDebounce } from 'react-table';
import { Input } from 'reactstrap';

const ReactTableFilter = ({
  rows,
  setGlobalFilter, setFilterValue, searchFieldMinWidth,
  globalFilter, placeholder, dataLength, gotoPage,
}) => {
  const [value, setValue] = useState(globalFilter || '');
  const onChange = useAsyncDebounce((item) => {
    setGlobalFilter(item || undefined);
  }, 200);

  useEffect(() => {
    if (value) {
      setFilterValue(value);
      gotoPage(0);
      console.log('go to page 0');
    }
  }, [value]);

  return (
    <div className="table__search" style={{ marginBottom: '0px' }}>
      <Input
        className="table__search table__search-input"
        value={value || ''}
        onChange={(e) => {
          setValue(e.target.value);
          onChange(e.target.value);
        }}
        type="search"
        placeholder={`${placeholder}`}
        style={{ minWidth: searchFieldMinWidth }}
      />
      {dataLength !== rows.length && (
        <span>Found {rows.length} matches</span>
      )}
    </div>
  );
};

const filterGreaterThan = (rows, id, filterValue) => rows.filter((row) => {
  const rowValue = row.values[id];
  return rowValue >= filterValue;
});

filterGreaterThan.autoRemove = val => typeof val !== 'number';

ReactTableFilter.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  setGlobalFilter: PropTypes.func.isRequired,
  setFilterValue: PropTypes.func,
  globalFilter: PropTypes.string,
  placeholder: PropTypes.string,
  dataLength: PropTypes.number.isRequired,
  gotoPage: PropTypes.func.isRequired,
  searchFieldMinWidth: PropTypes.string,
};

ReactTableFilter.defaultProps = {
  setFilterValue: () => {},
  globalFilter: undefined,
  placeholder: 'Search...',
  searchFieldMinWidth: '20%',
};

export default ReactTableFilter;
